import LogoIcon from "@/core/components/logo-icon";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { IPayout } from "@/payouts/payouts";

interface AlreadyPaidOutProps {
  payout: IPayout;
}

export const AlreadyPaidOut = ({ payout }: AlreadyPaidOutProps) => (
  <Stack
    align="center"
    fullWidth
    className="m-auto min-h-screen max-w-md bg-card p-8"
    gap="xl"
  >
    <LogoIcon />
    <Typography variant="subtitleW1" className="text-center">
      Payment Already Processed
    </Typography>
    <Typography variant="bodyW1" className="text-center text-[#637381]">
      This payout has already been claimed or processed.
      {payout?.business_name && (
        <>
          <br />
          <br />
          If you have any questions, please contact {payout.business_name}{" "}
          directly.
        </>
      )}
    </Typography>
  </Stack>
);
